import React from "react";

import { Divider } from "@mui/material";
import { Stack } from "@mui/system";
import { useTranslation } from "react-i18next";

import { AppConfig } from "../../../../constants";
import NotEnoughData from "../../../DashMetrics/NotEnoughData";
import useStyles from "./styles";

interface Props {
  data: number[];
  labels: string[];
  total: number;
}

const OverviewCardGraph = ({ data, labels, total }: Props) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  if (!total) return <NotEnoughData />;

  const percentages = data.map((value) => (total ? (value / total) * 100 : 0));
  const { locale } = AppConfig.locale;
  const formatNumber = Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format;

  return (
    <Stack
      direction="row"
      divider={<Divider orientation="vertical" flexItem />}
      spacing={2}
      sx={{ height: "100%", justifyContent: "space-between", width: "100%" }}
    >
      {labels.map((label, idx) => {
        return (
          <Stack
            direction="column"
            key={`${label}`}
            sx={{ flexGrow: 1, justifyContent: "space-between" }}
          >
            <div className={classes.title}>{translate(label)}</div>
            <div className={classes.value}>
              {data[idx] && <span>{formatNumber(data[idx])}</span>}
            </div>
            <Divider light />
            <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
              <div className={classes.label}>{translate("ofTotal")}</div>
              <div className={classes.label}>
                {percentages[idx] && <span>{formatNumber(percentages[idx])}</span>}%
              </div>
            </Stack>
          </Stack>
        );
      })}
    </Stack>
  );
};

export default OverviewCardGraph;
